import { useEffect, useState } from 'react';
import { supabase } from '../../../lib/supabase';
import type { ProjectAddress } from '../types';

export function useProjectAddresses(projectId: string | null) {
  const [addresses, setAddresses] = useState<ProjectAddress[]>([]);

  useEffect(() => {
    if (!projectId) { setAddresses([]); return; }
    supabase
      .from('project_addresses')
      .select('*')
      .eq('project_id', projectId)
      .order('created_at')
      .then(({ data }) => setAddresses(data ?? []));
  }, [projectId]);

  const addAddress = async (
    name: string,
    street: string,
    houseNumber: string,
    postalCode: string,
    city: string,
  ): Promise<ProjectAddress | null> => {
    if (!projectId) return null;
    try {
      const isFirst = addresses.length === 0;
      const { data, error } = await supabase
        .from('project_addresses')
        .insert({
          project_id: projectId,
          name,
          street,
          house_number: houseNumber,
          postal_code: postalCode,
          city,
          is_default: isFirst,
        })
        .select()
        .single();
      if (error) throw error;
      const created = data as ProjectAddress;
      setAddresses((prev) => [...prev, created]);
      return created;
    } catch {
      return null;
    }
  };

  return { addresses, addAddress };
}
